import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "Select" }




export default /*#__PURE__*/_defineComponent({
  ...{
    name: "inn-select",
},
  __name: 'Select',
  props: /*#__PURE__*/_mergeModels({
    items: {
        type: Array,
        required: true,
    },
    itemTitle: {
        type: String,
        required: false,
        default: null,
    },
    itemValue: {
        type: String,
        required: false,
        default: null,
    },
    compact: {
        type: Boolean,
        required: false,
        default: false,
    },
}, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props) {





const model = _useModel(__props, "modelValue");

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_select, {
      "data-compact": __props.compact,
      items: __props.items,
      modelValue: model.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
      "item-title": __props.itemTitle,
      "item-value": __props.itemValue,
      density: "compact"
    }, null, 8, ["data-compact", "items", "modelValue", "item-title", "item-value"])
  ]))
}
}

})